import { QueryList } from "@angular/core";
import { BehaviorSubject, combineLatest, Subscription } from "rxjs";
import { NestedDirective } from "../component/nested.directive";

export class FilteredNested {
    private _filteredList: BehaviorSubject<NestedDirective[]>;
    private onVisibleChangeSubscription: Subscription;
    private onListChangeSubscription: Subscription;

    constructor(list: QueryList<NestedDirective>) { 
        this._filteredList = new BehaviorSubject<NestedDirective[]>(this.filter(list.toArray()));
        this.onVisibleChangeSubscription = this.subscribeToVisibility(list, this._filteredList);

        this.onListChangeSubscription = list.changes.subscribe(() => {
            this.onVisibleChangeSubscription.unsubscribe();

            this._filteredList.next(this.filter(list.toArray()));
            this.onVisibleChangeSubscription = this.subscribeToVisibility(list, this._filteredList);
        });
    }

    private filter = (list: NestedDirective[]): NestedDirective[] => list.filter(nested => nested.isVisible);

    private subscribeToVisibility = (list: QueryList<NestedDirective>, filteredList: BehaviorSubject<NestedDirective[]>): Subscription => {
        return combineLatest(list.map(nested => nested.isVisibleObservable))
            .subscribe(() => filteredList.next(this.filter(list.toArray())));
    }

    get value(): NestedDirective[] {
        return this._filteredList.value;
    }

    public complete = (): void => {
        this._filteredList.complete();
        this.onVisibleChangeSubscription.unsubscribe();
        this.onListChangeSubscription.unsubscribe();
    }
}